import React from 'react';
import { Truck } from 'lucide-react';

// Flat-rate shipping banner — $9.99 to every U.S. zip.
const FreeShipBar = ({ dark = false }) => {
  const textColor = dark ? 'text-[#e7d3a1]' : 'text-[#4a463d]';
  return (
    <div className="mb-5" data-testid="free-ship-bar">
      <div className={`flex items-center gap-2 font-body text-xs ${textColor}`}>
        <Truck size={14} className="text-[#c6a15b] shrink-0" />
        <span><strong className="text-[#c6a15b]">Flat $9.99</strong> U.S. shipping — same rate to every zip.</span>
      </div>
    </div>
  );
};

export default FreeShipBar;
